export const AUTH_ROUTE_NAMES = {
  LOGIN: 'login',
  ACTIVATE_ACCOUNT: 'ativar-conta',
  VERIFY_ACCOUNT: 'verificar-conta',
  VERIFY_PHONE: 'verificar-celular',
  CONFIRM_PHONE: 'confirmar-celular',
  CREATE_PASSWORD: 'criar-senha',
  FORGOT_MY_PASSWORD: 'esqueci-minha-senha',
  UPDATE_REGISTRATION_INFORMATION: 'atualizar-dados-cadastrais',
  UPDATE_PASSWORD: 'alterar-senha',
  ASSISTED_MODE: 'modo-assistido',
  ASSISTED_MODE_CLIENT_LOGIN: 'modo-assistido-login-cliente',
  UPDATE_MY_PASSWORD: 'atualizar-senha',
};
